import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CardMercado from '../../views/mercadoPublico/cardMercado';

const Seccion = ({ seccion }) => {
    if (!seccion || !seccion.vehiculos || !seccion.categoria) return null;
    return (
        <>
            <Container fluid >
                <Row className="px-0 px-md-1">
                    <Col className="bg-white my-3 my-md-4 pl-3 pl-md-3" xs={12}>
                        <h5 className="bold-title-hyundai ml-0 mb-0 font-title-mobile">{seccion.categoria}</h5>
                    </Col>
                </Row>
                
                <Row className="border-row-mp">
                    {seccion.vehiculos && seccion.vehiculos.length > 0 &&
                        seccion.vehiculos.map((vehiculo, i) => <CardMercado vehiculo={vehiculo} key={i} />)
                    }
                </Row>
            </Container>
        </>
    );
}

export default Seccion;